import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ConfirmModal from '../components/common/ConfirmModal';

const ConfirmContext = createContext(null);

const normalizeConfirmOptions = (options) => {
  if (typeof options === 'string') {
    return { message: options };
  }
  return options || {};
};

export const ConfirmProvider = ({ children }) => {
  const [confirmState, setConfirmState] = useState(null);

  const confirm = useCallback((options) => {
    return new Promise((resolve) => {
      setConfirmState({
        ...normalizeConfirmOptions(options),
        resolve,
      });
    });
  }, []);

  const handleClose = useCallback(
    (confirmed) => {
      if (confirmState?.resolve) {
        confirmState.resolve(confirmed);
      }
      setConfirmState(null);
    },
    [confirmState],
  );

  const contextValue = useMemo(() => ({ confirm }), [confirm]);

  return (
    <ConfirmContext.Provider value={contextValue}>
      {children}
      {confirmState && (
        <ConfirmModal
          title={confirmState.title || 'Confirm action'}
          message={confirmState.message}
          confirmLabel={confirmState.confirmLabel || 'Confirm'}
          cancelLabel={confirmState.cancelLabel || 'Cancel'}
          showCancel={confirmState.showCancel !== false}
          onConfirm={() => handleClose(true)}
          onCancel={() => handleClose(false)}
        />
      )}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within a ConfirmProvider');
  }
  return context.confirm;
};